/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import * as THREE from 'three';
import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Trail, Float, Sphere } from '@react-three/drei';
import { EffectComposer, Bloom } from '@react-three/postprocessing';

interface AtomProps {
  [key: string]: unknown;
}

function Atom(props: AtomProps) {
  return (
    <group {...props}>
      <Electron position={[0, 0, 0.5]} speed={6} />
      <Electron
        position={[0, 0, 0.5]}
        rotation={[0, 0, Math.PI / 3]}
        speed={6.5}
      />
      <Electron
        position={[0, 0, 0.5]}
        rotation={[0, 0, -Math.PI / 3]}
        speed={7}
      />
      <Sphere args={[0.35, 64, 64]}>
        <meshBasicMaterial color={[6, 0.5, 2]} />
      </Sphere>
    </group>
  );
}

interface ElectronProps {
  radius?: number;
  speed?: number;
  [key: string]: unknown;
}

function Electron({ radius = 2.75, speed = 6, ...props }: ElectronProps) {
  const ref = useRef<THREE.Mesh>(null);
  useFrame(state => {
    if (ref.current) {
      const t = state.clock.getElapsedTime() * speed;
      ref.current.position.set(
        Math.sin(t) * radius,
        (Math.cos(t) * radius * Math.atan(t)) / Math.PI / 1.25,
        0
      );
    }
  });
  return (
    <group {...props}>
      <Trail
        local
        width={5}
        length={10}
        color={new THREE.Color(2, 1, 10)}
        attenuation={t => t * t}
      >
        <mesh ref={ref}>
          <sphereGeometry args={[0.25]} />
          <meshBasicMaterial color={[10, 1, 10]} />
        </mesh>
      </Trail>
    </group>
  );
}

export const Atom3D = (): React.ReactNode => {
  return (
    <Canvas
      camera={{ position: [0, 0, 10] }}
      gl={{
        antialias: true,
      }}
      style={{
        width: '100%',
        height: '600px',
        background: 'transparent',
      }}
    >
      <Float speed={4} rotationIntensity={1} floatIntensity={2}>
        <Atom />
      </Float>
      <EffectComposer>
        <Bloom mipmapBlur={false} luminanceThreshold={1} radius={0.8} />
      </EffectComposer>
    </Canvas>
  );
};
